<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7ZErW6/CoverDesign.jpg?1689204536162" alt="This image is the cover for the book The Bad Boy Next Door, Dangerous Desire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Bad Boy Next Door, Dangerous Desire
      </h1>
      <p class="bookDescription body article font2">
        <i>The Bad Boy Next Door</i> is a gripping tale about a dangerous man and the woman who is willing to take a chance for the ultimate reward…love! Award-winning erotic romance author Lexxie Couper does it again with her new contemporary romance about risking it all for the bad boy next door!<br/><br/>He's dangerous.<br/><br/>He came into my life when I was sixteen. Tattooed, ear pierced, ripped jeans and bloody knuckled. That was the day his family moved in next door.<br/><br/>For six years, I've watched my bad-boy neighbor, never knowing when he's going to be there and when he isn't. Never knowing what he's doing when he's absent, only that it's dangerous.<br/><br/>And then one night I wake to find him in my bed. Naked. Bruised and bleeding. And hard. Really hard.<br/><br/>He wants me. And he knows I want him too. But he's dangerous. On every freaking level.<br/><br/>Oh boy, this is going to end in pain…<br/><br/>This erotic contemporary romance contains adult themes and is not intended for readers under the age of 18.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lexxie Couper
      </h2>
      
      <p class="authorDescription body article">International bestselling romance author Lexxie Couper started writing when she was six and hasn't stopped since. She's not a deviant, but she does have a deviant's imagination and a desire to entertain readers with her words. Add the two together and you get erotic romances that can make you laugh, cry, shake with fear or tremble with desire…Sometimes all at once.<br><br>Connect with Lexxie online:<br><br>Email Lexxie at: lexxie@lexxiecouper.com<br><br>Twitter: http://twitter.com/lexxie_couper<br><br>Visit Lexxie's website at http://www.lexxiecouper.com, where she occasionally makes a fool of herself on her blog.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Book Boutiques
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?361ae030